const info = {
  ZH: { //中文翻译
    title: "\u534A\u6210\u54C1\u4EF6",
    type: "\u7C7B\u578B",
    cid: "ID",
    ver: "\u7248\u672C",
    enterprise: "\u521B\u5EFA\u4F01\u4E1A",
    cname: "\u534A\u6210\u54C1\u4EF6\u540D\u79F0",
    cfrname: "\u534A\u6210\u54C1\u4EF6\u540D\u79F0(\u5916\u6587)",
    csymbol: "\u534A\u6210\u54C1\u4EF6\u53F7",
    ccalReuseRate: "\u8BA1\u7B97\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387",
    cmeaReuseRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387",
    ccalRecycleRate: "\u8BA1\u7B97\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387",
    cmeaRecycleRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387",
    sample: "\u521d\u7248",
  },
  EN: { //英文翻译
    title: "Semicomponent",
    type: "Type",
    cid: "ID",
    ver: "Version",
    enterprise: "Supplier",
    cname: "Article Name",
    cfrname: "Article Name(Foreign)",
    csymbol: "Semicomponent No.",
    ccalReuseRate: "Calculated RecyclabilityRate",
    cmeaReuseRate: "Measured RecyclabilityRate",
    ccalRecycleRate: "Calculated RecoverabilityRate",
    cmeaRecycleRate: "MeasuredRecoverabilityRate",
    sample: "Sample",
  }
}
export default info //需要暴露出去
